module.exports = __webpack_public_path__ + "static/media/collapse-arrow-up.5b08e54c.svg";